// Sanitizes and validates a sell amount string input, removing commas, handling decimals, and enforcing max decimal places
export const returnSanitizedSellAmount = (input: string, maxDecimals: number): string | undefined => {
    if (input === '') {
        return '' // Return empty string instead of '0'
    }
    // Step 1: Remove all commas from the input
    let sanitizedInput = input.replace(/,/g, '').trim()

    // Step 2: Define regex to match valid numeric formats
    const validNumberPattern = /^(?:\d+(\.\d+)?|0\.?|\d+\.)$/

    // Step 3: Check against the pattern
    if (validNumberPattern.test(sanitizedInput)) {
        // Step 4: Remove leading zeros for integers with non-zero parts
        sanitizedInput = sanitizedInput.replace(/^0+(\d)/, '$1')

        // Step 5: Truncate to the maximum number of decimals, if applicable
        if (sanitizedInput.includes('.')) {
            const [integerPart, decimalPart] = sanitizedInput.split('.')
            sanitizedInput =
                decimalPart.length > maxDecimals
                    ? `${integerPart}.${decimalPart.slice(0, maxDecimals)}`
                    : sanitizedInput
        }

        // Step 6: Return sanitized input
        return sanitizedInput
    }

    return undefined
}

export function formatNumberStringWithCommas(input: string | undefined): string | undefined {
    if (input === undefined) {
        return input
    }

    if (input === '') {
        return '' // Return empty string for empty input
    }

    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = input.split('.')
    const dot = input.includes('.') ? '.' : ''

    // Add commas to the integer part using a regular expression
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    // Return the combined formatted number
    return `${formattedInteger}${dot}${decimalPart ? decimalPart : ''}`
}
